import { forwardRef, useContext, useRef } from "react";
import ManualTable from "../../ManualTable/ManualTable";
import { PrintDataContext } from "../../../Pages";


const ComponentToPrintBill = forwardRef((props, billPrintDataRef) => {
  // اگه در حالت پرینت بازم نیاز بود که داده ها ویرایش بشن. از همنیجا میتونیم کلی ااستایل خوشگل ست کنیم.
  const billPrintStyle = `
        .bill-container{
            direction:rtl;
        }
        table{
            width:100%;
        }
`;
  const billData = useContext(PrintDataContext);
  if (billData === 0) {
    // default value is 1
    return (
      <div
        ref={billPrintDataRef}
        className={" text-center align-content-center w-100 py-5 my-5"}
      >
        چیزی برای پرینت وجود ندارد! لطفا در جای مناسب کلیک کنید تا صفحه پرینت با
        محتوای درخواستی آماده پرینت شود.
      </div>
    );
  } else if (billData.data.data.length === 0) {
    return (
      <div
        ref={billPrintDataRef}
        className={" text-center align-content-center w-100 py-5 my-5"}
      >
        در این سطح اطلاعاتی جهت صورت حساب وجود ندارد
      </div>
    );
  }
  return (
    <>
      <style>{billPrintStyle}</style>

      <div ref={billPrintDataRef}>
        <div className="bill-container">
          <div className="bill-header">
            <h4>صورتحساب</h4>
            <div className="header-captions">
              <span className="bill-date">
                تاریخ: {billData.header.date}
                <span className="bill-date-time">
                  ساعت: {billData.header.time}
                </span>
              </span>
              <span className="bill-code">
                شماره حساب: {billData.header.code}
              </span>
              <span className="bill-title">
                عنوان حساب: {billData.header.title}
              </span>
            </div>
          </div>
          <ManualTable data={billData.data} />
        </div>
      </div>
    </>
  );
});

export default ComponentToPrintBill;
